/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, Backbone, mixpanel */

_.namespace(`mp.static.landing.marketing`, function(ns) {
  'use strict';

  const CookieTracker = require(`./cookie-tracker`);

  ns.pages = {};

  ns.init = function() {
    ns = _.extend(ns, Backbone.Events);

    ns.on(`page:init`, function() {
      var page = $(`[data-page]`).attr(`data-page`);

      if (page) {
        ns.pages[page]();

        setTimeout(function() {
          $(`.anim-hero`).addClass(`anim-hero-complete`);
        }, 50);

        ns.track_pages_visited();
      }
    });

    CookieTracker.setTrackingCookies();

    $(function() {
      ns.trigger(`page:init`);
    });

    $(window).load(ns.track_pages_visited);
  };

  ns.track_pages_visited = function() {
    if (mixpanel.get_property) {
      var page = $(`[data-page]`).attr(`data-page`);
      var pages_visited = mixpanel.get_property(`marketing_pages_visited`) || [];

      if (pages_visited.indexOf(page) === -1) {
        pages_visited.push(page);
        pages_visited.sort();

        mixpanel.register({
          marketing_pages_visited: pages_visited,
        });
      }
    }
  };
});

}.call(window));